<template>
  <div class="dp-container">
    <div v-for="(month, index) in months" :key="index" class="pb-8 px-3 -mx-3 overflow-hidden">
      <calendar-header :month="month" />
      <calendar-grid
        :month="month"
        :value="value"
        @click="handleDateClicked" />
    </div>
  </div>
</template>

<script>
import CalendarHeader from './CalendarHeader'
import CalendarGrid from './CalendarGrid'
import { mapState } from 'vuex'

export default {
  components: {
    CalendarHeader,
    CalendarGrid
  },
  computed: {
    ...mapState(['formData']),
    months () {
      let cursor = moment().startOf('month')
      const numberOfMonths = 25
      const months = []

      while (months.length < numberOfMonths) {
        months.push(cursor)

        cursor = moment().add(months.length, 'months')
      }

      return months
    },
    value () {
      return moment(this.formData.date)
    }
  },
  methods: {
    handleDateClicked (date) {
      this.$store.commit('setMobileFormData', {
        key: 'date',
        value: date
      })
      this.$store.commit('setForceShowDatePicker', false)
    }
  }
}
</script>

<style scoped>
.dp-container {
  max-width: 320px;
  margin: auto;
}
</style>